import { render } from "./barkasQuote.vue?vue&type=template&id=6733baba"
import script from "./barkasQuote.vue?vue&type=script&lang=js"
export * from "./barkasQuote.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__